import { render, staticRenderFns } from "./WillSummary.vue?vue&type=template&id=673b0282&scoped=true&"
import script from "./WillSummary.vue?vue&type=script&lang=js&"
export * from "./WillSummary.vue?vue&type=script&lang=js&"
import style0 from "./WillSummary.vue?vue&type=style&index=0&id=673b0282&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673b0282",
  null
  
)

export default component.exports